import React, { useCallback, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { useStores } from "../../hooks/useStores";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { Container, LoginTitle } from "./styled";
import { SignUpForm } from "../../components/SignUpForm";
import { Link, Text } from "@chakra-ui/layout";
import { Box, useToast } from "@chakra-ui/react";
import { isMobile } from "react-device-detect";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";

export const SignUp: React.FC = observer(() => {
  const { session } = useStores();
  const { t } = useTranslation();
  const toast = useToast();

  // useEffect(() => {
  //   ReactGA.pageview("/sign-up");
  // }, []);

  const handleSubmit = useCallback(
    async (
      name: string,
      surname: string,
      email: string,
      password: string,
      phone: string
    ) => {
      try {
        await session.signUp(name, surname, email, password, phone);
        ReactGA.event({
          category: "Customer",
          action: "Iscrizione Prova",
        });
        ReactPixel.track("Iscrizione Prova");
      } catch (err) {
        console.log(err);
        toast({
          title: t("common.error"),
          status: "error",
        });
      }
    },
    [session, t, toast]
  );

  if (session.isLogged) {
    return <Redirect to={"/"} />;
  }

  return (
    <Container>
      <Box
        boxShadow=" 0px 0px 20px rgba(51, 102, 255, 0.15)"
        p="32px"
        rounded="32px"
        bg="white"
        minH="400px"
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
      >
        <div style={{ textAlign: "center", width: isMobile ? "" : "400px" }}>
          <LoginTitle>{t("screens.signUp.title")}</LoginTitle>
          <SignUpForm onSubmit={handleSubmit} />
        </div>
        <Text style={{ marginTop: "1rem", textAlign: "center" }}>
          <Link color="#000" href={"#/login"} fontSize={10} fontWeight={500}>
            {t("screens.signUp.hasAccount")}
          </Link>
        </Text>
      </Box>
    </Container>
  );
});
